module.exports = __webpack_public_path__ + "static/media/ex-referral-icon1.171d0955.svg";